import { Semver } from '../../utils/Semver';
export function lessThanEqualToSemverMatcherContext(ruleAttr) {
    var ruleSemver = new Semver(ruleAttr);
    return function lessThanEqualToSemverMatcher(runtimeAttr) {
        var runtimeSemver = new Semver(runtimeAttr);
        var isLessThanEqual = runtimeSemver.compare(ruleSemver) <= 0;
        return isLessThanEqual;
    };
}
